import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  ListItemText,
  MenuItem,
  Tooltip
} from "@mui/material";
import { useState } from "react";
import { exportToCSV, exportToExcel } from "../../../util/files";
import { StyledExportButton } from "../../styled/ExportButton";


const ExportButton = ({ data, columns, title, disabled, color, fileName }) => {

  const [openMenu, setOpenMenu] = useState(null);

  const handleClose = (event) => {
    setOpenMenu(null);
  };

  const handleClickMenu = (event) => {
    setOpenMenu(event.currentTarget);
  };

  return (
    <>
      <StyledExportButton.Container>
        <Tooltip title="Exportar" arrow>
          <span>
            <StyledExportButton.Icon
              size="medium"
              onClick={handleClickMenu}
              disabled={disabled}
            >
              <FileDownloadIcon />
            </StyledExportButton.Icon>
          </span>
        </Tooltip>
      </StyledExportButton.Container>
      <StyledExportButton.Menu
        id="simple-menu"
        anchorEl={openMenu}
        keepMounted
        open={Boolean(openMenu)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => exportToCSV(columns, data, title, fileName)}>
          <ListItemText primary="Exportar CSV" />
        </MenuItem>
        <MenuItem onClick={() => exportToExcel(columns, data, title, fileName)}>
          <ListItemText primary="Exportar XLSX" />
        </MenuItem>
      </StyledExportButton.Menu>
    </>
  );
};

export default ExportButton;
